<template>

  <div class="">

      <div class="clearfix row py-2 mb-2 no-margin"> <!-- Mustafijur: 19-05-2026: Removed: border-bottom-->
          <div class="col-sm-4 company-form-box-title pb-3 d-flex align-items-end pl-0"> <!-- Abdullah: 20-05-2026 -->
              <div>Waiting for Approval</div>
          </div>
          <div class="col-sm-3">
            <b-form-group v-if="current_module == 2" id="application_date-group" label="Date" label-for="application_date">
              <b-input-group class="mb-3">
                <b-form-input @input="getQueue" id="application_date" name="application_date" v-model="application_date" v-validate="{ required: false, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('application_date')" aria-describedby="application_date-feedback" data-vv-as="Date"/>
                <b-input-group-append>
                  <b-form-datepicker :max="new Date()" @input="getQueue" id="day_one" button-only right locale="en-US" v-model="application_date" />
                </b-input-group-append>
                <b-form-invalid-feedback id="application_date-feedback"> {{ veeErrors.first('application_date') }} </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
         <!-- Abdullah responsive added px-md-0  -->
        <div class="col-sm px-md-0">
          <b-form-group id="approvers_depth-group" label="Module" label-for="approvers_depth">
            <b-form-select id="approvers_depth" name="approvers_depth" @input="getQueue" v-model="current_module" :options="modules"></b-form-select>
          </b-form-group>
        </div>
        <!-- Abdullah responsive added text-left text-md-right pr-md-0  -->
        <div class="col-sm text-left text-md-left pr-md-0" v-if="current_module == 2">
          <b-form-group id="bulk_options-group" label="Bulk Option" label-for="bulk_options">
            <b-form-select id="bulk_options" name="bulk_options" @input="confirmUpdateStatus(selected_bulk_option)" v-model="selected_bulk_option" :options="bulk_options"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div v-if="current_module==1">
        <div class="row justify-content-center no-margin employee-table-wrapper">
          <div class="col-sm-12  px-0">
            <b-overlay :show="showoverlay_list" rounded="sm">
              <!-- Abdullah responsive added table responsive  -->
              <table class="employee-list-table table-responsive table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table">
                <thead class="" style="">
                <tr class="table-head">
                  <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"style="cursor:pointer;">

                    <template v-if="column.name !='to' && column.name !='from'">
                      <label class="custom-label"><span>{{column.label}}</span></label>
                    </template>
                    <template v-else>
                      <label class="custom-label"><span> {{column.label}}</span>
                        <div class="table-header">
                          <div class="table sub-header">(YYYY-MM-DD)</div>
                        </div>
                      </label>
                    </template>
                  </td>
                  <!-- Abdullah 19-05-26 added this -->
                  <td class="text-center">
                    <label class="custom-label"><span>Action</span></label>
                  </td>
                </tr>
                </thead>
                <tbody>
                <template v-for="(leave , n) in paginatedData">
                  <tr class="table-row hover-bg" :key="n">
                    <td class=" ">
                      <div class="img-holder">
                        <img v-if="leave.employee_pic != ''" v-bind:src="$api_url+'/images/employee/'+ leave.company_id + '/' + leave.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                        <img v-else v-bind:src="$api_url+'/images/employee/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
                      </div>
                      <div class="name-holder">
                        {{leave.employee_name}}<br />
                        <span class="txt-alt">{{leave.employee_code}}</span>
                      </div>
                    </td>
                    <td class="">
                      {{leave.department}}
                    </td>
                    <td class="">
                      {{leave.jobposition}}
                    </td>
                    <td class="">
                      <img v-if="leave.leave_type == 'Sick Leave'" v-bind:src="$api_url+'/images/menu/hospital.svg'" class="mr-3"/>
                      <img v-else-if="leave.leave_type == 'Casual Leave'" v-bind:src="$api_url+'/images/menu/plane.png'" class="mr-3"/>
                      <img v-else v-bind:src="$api_url+'/images/menu/clock.png'" class="mr-3"/>
                      {{leave.leave_type}}
                    </td>
                    <td class="">
                      {{leave.from}}
                    </td>
                    <td class="">
                      {{ leave.to }}
                    </td>
                    <td class="">

                      <template v-if="leave.leave_day == 0">
                        {{leave.number_of_days}}
                        <span v-if="leave.number_of_days > 1">days</span>
                        <span v-else>day</span>
                      </template>
                      <template v-else-if="leave.leave_day == 1">First Half</template>
                      <template v-else-if="leave.leave_day == 2">Second Half</template>
                    </td>
                    <td class="">
                      {{leave.reason}} <br />
                      <b-link v-if="leave.attachment != null" @click="downloadFileContent('/images/employee/'+ leave.company_id + '/leaves/' + leave.attachment)"><img :src="$api_url+'/images/download_image.png'"  class="" /> </b-link>
                    </td>
                    <td class="">
                      {{leave.updated_by}}
                    </td>

                    <!-- Abdullah responsive added text-right  -->
                    <td class="position-relative text-right">
                      <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                      <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-toolbar class="">
                          <b-button-group class="mr-0">
                            <b-button class="mr-3 rounded edit-btn" title="Approve" v-if="leave.flg_status == 0" @click="updateLeaveStatus(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 1)">
                              <b-icon icon="check" class="mr-2" aria-hidden="true" ></b-icon>Approve
                            </b-button>
                            <b-button class="mr-3 rounded edit-btn" title="Reject" v-if="leave.flg_status == 0" @click="updateLeaveStatus(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 2)">
                              <b-icon icon="x" class="mr-2" aria-hidden="true" ></b-icon>Reject
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>


              <div v-if="paginatedData.length == 0" class="list-no-data">
                No records found.
              </div>
              <div v-else class="">
                <div class="clearfix mt-2 mb-4">
                  <ul class="pagination b-pagination float-left mb-0 mt-1">
                    <li class="page-item disabled m-2">View</li>
                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                    <li class="page-item disabled m-2">per page. Total {{queue.length}} records found.</li>
                  </ul>
                  <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

                </div>
              </div>
            </b-overlay>
          </div>
        </div>

      </div>
      <div class="row justify-content-center no-margin" v-else-if="current_module==2">
          <div class="col-sm-12 px-0">
              <b-overlay :show="showoverlay_list" rounded="sm">
                <!-- Abdullah responsive added table responsive  -->
                  <table class="employee-list-table table-responsive table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table" style="min-width: 75vw;"> <!-- Mustafijur: 19-05-2026 75vw, employee-list-table-->
                      <thead>
                          <tr class="table-head">

                            <td class="checkbox-col"><input type="checkbox" v-model="selectAll" /><label></label></td> <!-- Mustafijur: 19-05-2026 75vw-->
                              <th>Employee</th>
                              <th>Department</th>
                              <th>Job Position</th>
                              <th>Time</th>
                              <th>Date</th>
                              <th>Note</th>
                              <!-- Abdullah 19-05-26 added -->
                              <th class="text-center">Action</th>
                          </tr>
                      </thead>
                      <tbody>
                        <!-- Abdullah responsive commented this  -->
                        <!-- <td>
                              <input type="checkbox" class="justify-content-center" v-model="selected" :value="application.application_id" />
                        </td> -->
                        <!-- Abdullah 21-05-26 added label  -->
                          <tr v-for="(application , i) in paginatedData" :key="i" class="table-row hover-bg">
                           <td class="text-center checkbox-col">
                            <input type="checkbox" v-model="selected" :value="application.application_id" />
                            <label></label>
                            </td>
                            <td class="border-left">
                              <div class="img-holder">
                                <img v-if="application.employee_pic != ''" v-bind:src="$api_url+'/images/employee/'+ application.company_id + '/' + application.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                <img v-else v-bind:src="$api_url+'/images/employee/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
                              </div>
                              {{ application.name }}
                            </td>
                            <td class="border-left">{{ application.department }}</td>
                            <td class="border-left">{{ application.jobposition }}</td>

                              <td>{{ application.time }}</td>
                              <td>{{ application.date }}</td>

                              <td>{{ application.note }}</td>

                              <td class="position-relative text-right" >
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;"
                                  href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <b-icon icon="three-dots-vertical"></b-icon>
                                </a>

                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                  <b-button-toolbar>
                                    <b-button-group class="mr-0">
                                      <b-button class="mr-3 rounded edit-btn" title="Approve"
                                                @click="updateStatus([application.application_id], 1)">
                                        <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                                      </b-button>

                                      <b-button class="mr-3 rounded edit-btn" title="Reject"
                                                @click="updateStatus([application.application_id], 2)">
                                        <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                      </b-button>
                                    </b-button-group>
                                  </b-button-toolbar>
                                </div>
                              </td>
                            </tr>
                      </tbody>
                  </table>

                  <div v-if="queue.length == 0" class="list-no-data">
                      No records found.
                  </div>
                   <div v-else class="">
                      <div class="clearfix mt-2 mb-4">
                          <ul class="pagination b-pagination float-left mb-0 mt-1">
                              <li class="page-item disabled m-2">View</li>
                              <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                              <li class="page-item disabled m-2">per page. Total {{queue.length}} records found.</li>
                          </ul>
                          <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

                      </div>
                  </div>
              </b-overlay>
          </div>
      </div>

  </div>

</template>

<script>
export default {
  props: [],
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Employee', name: 'employee_name' },
      {label: 'Department', name: 'department' },
      {label: 'Job Position', name: 'jobposition' },
      {label: 'Leave Type', name: 'leave_type'},
      {label: 'From', name: 'from'},
      {label: 'To', name: 'to'},
      {label: 'No. of Days', name: 'number_of_days'},
      {label: 'Reason', name: 'reason'},
      {label: 'Updated By/Initiated By', name: 'updated_by'},
    ];
    columns.forEach((column) => {sortOrders[column.name] = -1;});
    return {

      queue:[],
      modules : {1:'Leave' , 2:'Attendance'},
      current_module : 1,
      selected_bulk_option : 0,
      application_date : '',
      selected:[],
      bulk_options:[
        {value:0, text: 'Bulk Option'},
        {value:1, text:'Approve Selected'},
        {value:2, text:'Reject Selected'},
      ],
      showoverlay_list:false,
      pagination: {currentPage: 1, pages:1},
      temp_length: 20,
      columns: columns,
      sortKey: 'employee_name',
      sortOrders: sortOrders,
      length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                              { value: 50, text: "50" },
                                              { value: 100, text: "100" },
                                              { value: 200, text: "200" },
                                              { value: 500, text: "500" }, ],
    };
  },
  methods: {


    getSettings() {
      Promise.all([
        axios.get(this.$api_url + '/front/approver/settings/1'),
        axios.get(this.$api_url + '/front/approver/settings/2')
      ]).then(([mod1, mod2]) => {
        if (mod1.data['status'] == 1) {
          this.modules.push({ value: 1, text: 'Leave' });
        }

        if (mod2.data['status'] == 1) {
          this.modules.push({ value: 2, text: 'Attendance' });
        }

        if (this.modules.length > 0) {
          this.current_module = this.modules[0].value;
          this.getQueue();
        }
      });
    },

    confirmUpdateStatus(status){
      if(status == 0) return;
      const actionText = status == 1 ? 'approve' : 'reject';
      this.$bvModal.msgBoxConfirm(
          `Do you want to ${actionText} the selected applications?`,
          {
            title: 'Are you sure?',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            centered: true
          }
      ).then(confirmed => {
        if (!confirmed) return;
        this.updateStatus(this.selected, status);
      });
    },
    updateLeaveStatus(employee_id,leave_type_id,flg_status,from,to , status){
      this.showoverlay_list = true;
      axios.post(this.$api_url + '/front/approver/application/'+this.current_module, {
            "employee_id": employee_id,
            "leave_type_id": leave_type_id,
            "from": from,
            "status": status,
            "to": to,
            "flg_status": flg_status,
          }).then(function (response) {
        this.$bvToast.toast('Updated!', {
          title: `Success`,
          variant: 'success',
          solid: true
        });
        this.getQueue();
      }.bind(this)).catch((error) => {
        this.showoverlay_list = false;
        this.serverError(error);
      });
    },

    updateStatus(ids, status){

      this.showoverlay_list = true;
      axios.post(this.$api_url + '/front/approver/application/'+this.current_module, {'ids': ids,'status':status}).then(function (response) {
            this.$bvToast.toast('Updated!', {
                  title: `Success`,
                  variant: 'success',
                  solid: true
                });
            this.getQueue();
            this.selected_bulk_option = 0;
            this.selected = [];
        }.bind(this)).catch((error) => {
            this.showoverlay_list = false;
            this.selected_bulk_option = 0;
            this.serverError(error);
        });

    },
    getQueue() {
      let params = {};
      if (this.current_module === 1) {
        this.application_date = '';
      } else if (this.application_date) {
        const date = new Date(this.application_date);
        const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!ymdPattern.test(this.application_date) || isNaN(date.getTime())) {
          return;
        }
        params['application_date'] = this.application_date;
      }
      this.showoverlay_list = true;

      axios.get(`${this.$api_url}/front/approver/queue/${this.current_module}`, { params }).then(response => {
            this.queue = response.data;
            this.showoverlay_list = false;
          }).catch(error => {
            this.showoverlay_list = false;
            this.serverError(error);
          });
    },
  },
  created() {

      this.getQueue();
    },

    computed:{
      filteredData()
      {
          let filtered_list = this.queue;
          this.people = filtered_list.length;
          if (this.search)
          {
              filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

              if(filtered_list.length == 0)
                  this.blankmsg = "Nothing found.";
          }

          return filtered_list;
      },
      paginatedData()
      {
          return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
      },

      selectAll: {
        get: function () {
          if(this.paginatedData.length == 0) return false;
          return this.paginatedData ? this.selected.length == this.paginatedData.length : false;
        },
        set: function (value) {
          let selected = [];
          if (value) {
            this.paginatedData.forEach(function (user) {
              selected.push(user.application_id);
            });
          }
          this.selected = selected;
        }
      },
    }

};
</script>
